/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import BannersData from "layouts/tables/data/bannersTableData";
import { useEffect, useRef, useState } from "react";
import { getBanners } from "api";
import { updateBannerSequence } from "api";
import { createBanners } from "api";
import { getPresignedUrl } from "api";
import axios from "axios";

function Banners() {
  const { sales, tasks } = reportsLineChartData;

  const [arrData, setArrData] = useState([]);
  const fileInputRef = useRef(null);
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    getBannersApi();
  }, []);

  const getBannersApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getBanners({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrData(responseJson?.banners);
          }
        }
      })
      .catch((e) => {});
  };

  const getUrl = async (fileType, media) => {
    var responseJson = await getPresignedUrl({
      params: {
        fileType: fileType,
      },
    });
    return uploadImage(media, responseJson, fileType);
  };

  async function uploadImage(file, data, fileType) {
    const preSignedUrl = data.uploadUrl;
    const originalUrl = data.originalUrl;

    try {
      const mimeType = file.type || "image/jpeg"; // Fallback if type not set

      // Create a blob directly from the File object
      const blob = file.slice();

      const uploadResponse = await fetch(preSignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": mimeType,
        },
        body: blob,
      });

      if (uploadResponse.ok) {
        return originalUrl; // Return public image URL
      } else {
        console.error("Upload failed:", uploadResponse.statusText);
        return false;
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      return false;
    }
  }

  const createBannersApi = async (media) => {
    const fileType = "jpg";

    // return;

    let values = await Promise.all([getUrl(fileType, media)]);

    var params = {
      imageUrl: values[0],
      sequence: arrData?.length + 1 || 1,
    };

    createBanners({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            getBannersApi();
          }
        }
      })
      .catch((e) => {});
  };

  const BannersLists = () => {
    return (
      <MDBox p={3}>
        <BannersData
          data={arrData || []}
          onPressAddBanner={onPressAddBanner}
          onReloadBanner={onReloadBanner}
        ></BannersData>
      </MDBox>
    );
  };

  const onReloadBanner = () => {
    getBannersApi();
  };

  const onPressAddBanner = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Do something with the image: upload, preview, create new banner, etc.
      createBannersApi(file);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Banners" />
      <MDBox py={3}>
        <Card>
          <BannersLists />
        </Card>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleImageChange}
        style={{ display: "none" }}
      />
    </DashboardLayout>
  );
}

export default Banners;
